module.exports = __webpack_public_path__ + "static/media/sample_bulk_upload_last_mile.93967aea.csv";